import {getData, LOGIN} from "../storage";
import {isEmpty} from "../utility";
import assets from "../assets";
import strings from "../strings";

const getUserDetailsByIdAPI = (props, user_id) => {
    getData(LOGIN).then((data) => {
        if (!isEmpty(data)) {
            props.getUserDetailsById(data.token, data.api_token, user_id);
        }
    })
}

const getFollowingListByIdAPI = (props, user_id, pageNo, query, filter_by) => {
    getData(LOGIN).then((data) => {
        if (!isEmpty(data)) {
            props.getFollowingListById(data.token, data.api_token, user_id, pageNo, query, filter_by);
        }
    })
}

const clickedOnFollowUnfollowAPI = (props, is_following, broadcaster_id) => {
    getData(LOGIN).then((data) => {
        if (!isEmpty(data)) {
            if (is_following) {

                const payload = {
                    image: assets.clipstore.home.more.more_unfollow,
                    title: strings.user.follow_unfollow.unfollow.title,
                    description: strings.user.follow_unfollow.unfollow.description,
                };
                const isConfirmationModal = true;
                const actionArray = [{
                    text: "NO",
                    click: () => {
                        console.log("Clicked on CANCEL");
                        props.hideCommonModal()
                    }
                }, {
                    text: "YES",
                    click: () => {
                        console.log("Clicked on OK")
                        props.unFollowBroadcaster(
                            data.token,
                            data.api_token,
                            broadcaster_id
                        );
                    }
                }];

                props.showCommonModal(payload, isConfirmationModal, actionArray);


            } else {
                props.followBroadcaster(
                    data.token,
                    data.api_token,
                    broadcaster_id
                );
            }
        }
    });
};

const clickedOnFavUnFavAPI = (props, is_favourite, user_id, broadcaster_id, cancelCallback) => {
    getData(LOGIN).then((data) => {
        if (!isEmpty(data)) {
            if (is_favourite) {

                const payload = {
                    image: assets.clipstore.home.more.more_fav,
                    title: strings.user.fav_unfav.unfav.title,
                    description: strings.user.fav_unfav.unfav.description,
                };
                const isConfirmationModal = true;
                const actionArray = [{
                    text: "NO",
                    click: () => {
                        console.log("Clicked on CANCEL");
                        props.hideCommonModal()
                        cancelCallback()
                    }
                }, {
                    text: "YES",
                    click: () => {
                        console.log("Clicked on OK")
                        props.unFavouriteUser(
                            data.token,
                            data.api_token,
                            user_id,
                            broadcaster_id
                        );
                    }
                }];

                props.showCommonModal(payload, isConfirmationModal, actionArray);


            } else {
                props.favouriteUser(
                    data.token,
                    data.api_token,
                    user_id,
                    broadcaster_id
                );
            }
        }
    });
};

const getFavList = (props) => {
    getData(LOGIN).then((data) => {
        if (!isEmpty(data)) {
            props.getFavouritesList(data.token, data.api_token, "", "");
        }
    })

}
export default {
    getUserDetailsByIdAPI,
    getFollowingListByIdAPI,
    clickedOnFollowUnfollowAPI,
    clickedOnFavUnFavAPI,
    getFavList
}